var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgESign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/edit-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.61763 16.2656C4.1093 16.2656 3.6343 16.0906 3.29263 15.7656C2.8593 15.3573 2.65097 14.7406 2.72597 14.074L3.0343 11.374C3.09263 10.8656 3.40097 10.1906 3.7593 9.82398L10.601 2.58232C12.3093 0.773983 14.0926 0.723983 15.901 2.43232C17.7093 4.14065 17.7593 5.92398 16.051 7.73232L9.2093 14.974C8.8593 15.349 8.2093 15.699 7.70096 15.7823L5.01763 16.2406C4.87597 16.249 4.75097 16.2656 4.61763 16.2656ZM13.276 2.42398C12.6343 2.42398 12.076 2.82398 11.5093 3.42398L4.66763 10.674C4.50097 10.849 4.3093 11.2656 4.27597 11.5073L3.96763 14.2073C3.9343 14.4823 4.00097 14.7073 4.15097 14.849C4.30097 14.9906 4.52597 15.0406 4.80097 14.999L7.4843 14.5407C7.72597 14.499 8.12597 14.2823 8.29263 14.1073L15.1343 6.86565C16.1676 5.76565 16.5426 4.74898 15.0343 3.33232C14.3676 2.69065 13.7926 2.42398 13.276 2.42398Z",
    fill: "#C34AFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.4497 9.12406C14.433 9.12406 14.408 9.12406 14.3914 9.12406C11.7914 8.86573 9.69971 6.89073 9.29971 4.30739C9.24971 3.96573 9.48305 3.64906 9.82471 3.59073C10.1664 3.54073 10.483 3.77406 10.5414 4.11573C10.858 6.13239 12.4914 7.68239 14.5247 7.88239C14.8664 7.91573 15.1164 8.22406 15.083 8.56573C15.0414 8.88239 14.7664 9.12406 14.4497 9.12406Z",
    fill: "#C34AFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.5 18.957H2.5C2.15833 18.957 1.875 18.6737 1.875 18.332C1.875 17.9904 2.15833 17.707 2.5 17.707H17.5C17.8417 17.707 18.125 17.9904 18.125 18.332C18.125 18.6737 17.8417 18.957 17.5 18.957Z",
    fill: "#C34AFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgESign);
export default __webpack_public_path__ + "static/media/e-sign.8fee75901016b6b8ff2dafe4ea0e7019.svg";
export { ForwardRef as ReactComponent };